/**
 * Turns trust bar items marked with data-trust-scroll into links down to
 * another section on the same page — the rating pointing at the testimonials
 * it was averaged from.
 *
 * The link cannot be written in Liquid: the target section carries a generated
 * id no other section can read. So the item ships as plain text and is upgraded
 * here, which also means it stays plain text on pages where the target is not
 * rendered at all rather than becoming a link to nowhere.
 */
(() => {
  if (window.trustBarScrollLinks) return;
  window.trustBarScrollLinks = true;

  let anchorCount = 0;

  const upgrade = (item) => {
    const target = document.querySelector(item.dataset.trustScroll);
    if (!target) return;

    if (!target.id) {
      anchorCount += 1;
      target.id = `TrustBarTarget-${anchorCount}`;
    }

    // A real anchor, so the item keeps the keyboard, focus and context-menu
    // behaviour a click handler on a span would have to reinvent. The glide
    // itself is the theme's own scroll-behavior on <html>.
    const link = document.createElement('a');
    Array.from(item.attributes).forEach((attribute) => {
      link.setAttribute(attribute.name, attribute.value);
    });
    link.removeAttribute('data-trust-scroll');
    link.href = `#${target.id}`;
    link.append(...item.childNodes);
    item.replaceWith(link);
  };

  const upgradeAll = (root) => {
    root.querySelectorAll('[data-trust-scroll]').forEach(upgrade);
  };

  upgradeAll(document);

  // The theme editor re-renders a section's markup on every settings change,
  // which drops the upgraded links back to their unlinked state.
  document.addEventListener('shopify:section:load', (event) => upgradeAll(event.target));
})();
